class AppraisalConcludeController {
  constructor(enums) {
    "ngInject";

    this.enums = enums;

    this.getAppraisalQuality();
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  getAppraisalQuality() {
    this.appraisalQualityList = this.convertEnumToKeyValueList(this.enums.APPRAISAL_QUALITY);
    this.appraisalQualityList.unshift({id: null, name: 'Please Select'});
  }
}

export default AppraisalConcludeController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/appraisalConclude/appraisalConclude.controller.js